import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { animeWorks } from '@/mocks/works';
import AnimeCard from '@/components/feature/AnimeCard';
import SectionHeading from '@/components/feature/SectionHeading';

export default function AnimeLibrarySection() {
  const { t } = useTranslation();
  const works = animeWorks.slice(0, 10);

  return (
    <section className="bg-background-100/60 py-12 md:py-16" aria-label={t('sec_anime_library')}>
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <SectionHeading title={t('sec_anime_library')} desc={t('sec_anime_library_desc')} />
          <Link
            to="/category/ri"
            className="mb-1 hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition hover:text-primary-700 sm:flex"
          >
            {t('sec_all')}
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
          {works.map((work) => (
            <AnimeCard key={work.id} work={work} />
          ))}
        </div>
      </div>
    </section>
  );
}